<template>
  <div>
  <v-dialog v-model="dialog" persistent max-width="800">
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">Analisar Processo de Pagamento</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="$emit('onCloseReport')" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <!-- Remoção a pedido do everton em 03/05/21 -->
        <!-- <v-row>
          <v-col>
            <h1>Anexos</h1>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              :headers="headersAnexos"
              :items="report.anexos"
              class="elevation-1"
              hide-default-footer
              disable-pagination
            >
              <template v-slot:item.download="{ item }">
                <v-btn
                  outlined
                  color="primary"
                  class="ml-3"
                  @click="downloadAnexoProcessoPagamento(item)"
                >
                  <span>Download</span>
                </v-btn>
              </template>

              <template slot="no-data">
                <span>
                  Nenhum anexo retornado
                </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col>
            <v-text-field
              label="Número da entrega"
              name="numero"
              type="number"
              required
              v-model="report.numero"
              :disabled="true"
              filled
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Total de entregas"
              name="total"
              type="number"
              required
              v-model="report.total"
              :disabled="true"
              filled
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Total de horas do processo de pagamento"
              name="total"
              type="number"
              required
              hide-details="auto"
              :disabled="true"
              filled
              v-model="payload.horas"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              label="Código da Contratação"
              name="codigocontratacao"
              type="text"
              required
              v-model="report.codigoContratacao"
              :disabled="true"
              filled
              hide-details="auto"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              label="Tipo de Produto"
              name="tipoprocesso"
              type="text"
              required
              :value="
                report.solucoesTipo && report.solucoesTipo.solucaoTipoNome
              "
              :disabled="true"
              filled
              hide-details="auto"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              label="Período de Realização (dd/mm/yyyy - dd/mm/yyyy)"
              name="realizacao"
              type="text"
              v-mask="'##/##/#### - ##/##/####'"
              required
              v-model="report.periodoRealizacao"
              :disabled="report.statusId !== 1 ? false : true"
              filled
              hide-details="auto"
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- Accordion de Informações do Contrato -->
        <v-row v-if="report?.contrato">
          <v-col>
            <v-expansion-panels
              v-model="contractPanel"
              multiple
              class="mt-3 contract-expansion-panels"
              color="primary"
            >
              <v-expansion-panel
                class="contract-expansion-panel"
                color="primary"
              >
                <v-expansion-panel-header
                  class="contract-panel-header"
                  color="primary"
                >
                  <div class="d-flex align-center">
                    <div class="icon-wrapper mr-3">
                      <v-icon color="white" size="20"
                        >mdi-file-document-outline</v-icon
                      >
                    </div>
                    <span class="panel-title">Informações do Contrato</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="contract-panel-content">
                  <ContractInfoCard
                    :contract-data="report.contrato"
                    subtitle="Informações detalhadas do contrato"
                    :max-description-length="200"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h1>Relatórios</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="report.relatorioPagamento"
              item-key="relatorioPagamentoId"
              class="elevation-1"
              hide-default-footer
              disable-pagination
              :single-expand="true"
              show-expand
              @item-expanded="onItemExpanded"
            >
              <!-- <template v-slot:item.relatorio.criacao="{ item }">
                {{ item.relatorio.criacao | moment("DD/MM/YYYY") }}
              </template> -->
              <template v-slot:item.relatorio.criacao="{ item }">
                {{ item.relatorio.criacao | moment("DD/MM/YYYY") }}
              </template>

              <template slot="no-data">
                <span> Nenhum relatório retornado </span>
              </template>

              <template v-slot:expanded-item="{ item }">
                <td colspan="5" id="report-expanded">
                  <v-tabs vertical v-model="tab">
                    <v-tab :value="0">
                      <v-icon left>mdi-file-chart</v-icon>
                      Relatório
                    </v-tab>
                    <v-tab :value="1">
                      <v-icon left>mdi-account-multiple-plus</v-icon>
                      Convidados
                    </v-tab>
                    <v-tab :value="2" @click="onAnexosTabClick(item)">
                      <v-icon left>mdi-attachment</v-icon>
                      Anexos
                    </v-tab>
                    <v-tab :value="3">
                      <v-icon left>mdi-calendar-check-outline</v-icon>
                      {{ isAT || isGov ? "Atividades" : "Tarefas" }}
                    </v-tab>
                    <v-tab :value="4">
                      <v-icon left>mdi-android-messages</v-icon>
                      Observações
                    </v-tab>

                    <v-tab-item>
                      <v-col>
                        <v-textarea
                          v-model="item.relatorio.descricao"
                          readonly
                        ></v-textarea>
                        <div
                          v-if="canViewFullScreenReport"
                          class="full-screen-report-action"
                        >
                          <v-btn
                            small
                            outlined
                            color="primary"
                            @click.stop="
                              openFullScreenReport(item.relatorio.descricao)
                            "
                          >
                            Ver em tela inteira
                          </v-btn>
                        </div>
                      </v-col>
                    </v-tab-item>
                    <v-tab-item>
                      <v-data-table
                        :headers="headersConvidados"
                        :items="item.relatorio.convidados"
                        class="elevation-1"
                        hide-default-footer
                        disable-pagination
                      >
                        <template v-slot:item.presente="{ item }">
                          <v-checkbox
                            v-model="item.presente"
                            :id="'membro' + item.membroId"
                            color="primary"
                            disabled
                          >
                          </v-checkbox>
                        </template>

                        <template slot="no-data">
                          <span> Nenhum convidado retornado </span>
                        </template>
                      </v-data-table>
                    </v-tab-item>
                    <v-tab-item>
                      <v-data-table
                        :headers="headersAnexos"
                        :items="item.relatorio.anexos"
                        class="elevation-1"
                        hide-default-footer
                        disable-pagination
                      >
                        <template v-slot:item.nome="{ item }">
                          <span class="anexo-nome">{{ item.nome }}</span>
                        </template>
                        <template v-slot:item.download="{ item }">
                          <v-btn
                            outlined
                            color="primary"
                            class="ml-3"
                            @click="downloadAnexo(item)"
                          >
                            <span>Download</span>
                          </v-btn>
                        </template>

                        <template slot="no-data">
                          <span> Nenhum anexo retornado </span>
                        </template>
                      </v-data-table>
                    </v-tab-item>
                    <v-tab-item>
                      <v-data-table
                        :headers="headersTarefas"
                        :items="item.relatorio.tarefas"
                        class="elevation-1"
                        hide-default-footer
                        disable-pagination
                      >
                        <template v-slot:item.cumprida="{ item }">
                          <v-checkbox
                            v-model="item.cumprida"
                            :id="'cumprida' + item.tarefaId"
                            color="primary"
                            disabled
                          >
                          </v-checkbox>
                        </template>
                        <template
                          v-slot:item.tarefa.municipioTarefa.municipioEvidencias="{
                            item,
                          }"
                        >
                          <span
                            v-for="evidencia in item.municipioTarefa
                              .municipioEvidencias"
                            :key="evidencia.municipioEvidenciaId"
                          >
                            {{ evidencia.nome }} |
                          </span>
                        </template>

                        <template slot="no-data">
                          <span> Nenhuma tarefa retornada </span>
                        </template>
                      </v-data-table>
                    </v-tab-item>
                    <v-tab-item>
                      <v-col>
                        <v-textarea
                          v-model="item.relatorio.observacoes"
                          readonly
                        ></v-textarea>
                      </v-col>
                    </v-tab-item>
                  </v-tabs>
                </td>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <template
          v-if="
            !config.ocultarRelatorioAdministrativos &&
            !groupsConfig.ocultarRelatorioAdministrativos
          "
        >
          <v-row>
            <v-col>
              <h2>Relatórios administrativos</h2>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-data-table
                :headers="headersAdministrativeReport"
                :items="report.relatorioAdministrativoPagamento"
                item-key="relatorioAdministrativoPagamentoId"
                class="elevation-1"
                hide-default-footer
                disable-pagination
                :single-expand="true"
                show-expand
                @item-expanded="onAdministrativeItemExpanded"
              >
                <template
                  v-slot:item.relatorioAdministrativo.criacao="{ item }"
                >
                  {{
                    item.relatorioAdministrativo.criacao | moment("DD/MM/YYYY")
                  }}
                </template>

                <template v-slot:expanded-item="{ item }">
                  <td colspan="6" id="administrative-report-expanded">
                    <v-tabs vertical v-model="administrativeTab">
                      <v-tab :value="0">
                        <v-icon left>mdi-file-chart</v-icon>
                        Relatório
                      </v-tab>
                      <v-tab :value="1">
                        <v-icon left>mdi-attachment</v-icon>
                        Anexos
                      </v-tab>

                      <v-tab-item>
                        <v-col>
                          <v-textarea
                            :value="getAdministrativeReportDetails(item).descricao"
                            readonly
                          ></v-textarea>
                          <div
                            v-if="canViewFullScreenReport"
                            class="full-screen-report-action"
                          >
                            <v-btn
                              small
                              outlined
                              color="primary"
                              @click.stop="
                                openFullScreenReport(
                                  getAdministrativeReportDetails(item).descricao
                                )
                              "
                            >
                              Ver em tela inteira
                            </v-btn>
                          </div>
                        </v-col>
                      </v-tab-item>

                      <v-tab-item>
                        <v-data-table
                          :headers="headersAnexos"
                          :items="getAdministrativeReportDetails(item).anexos || []"
                          class="elevation-1"
                          hide-default-footer
                          disable-pagination
                        >
                          <template v-slot:item.nome="{ item }">
                            <span class="anexo-nome">{{ item.nome }}</span>
                          </template>
                          <template v-slot:item.download="{ item }">
                            <v-btn
                              outlined
                              color="primary"
                              class="ml-3"
                              @click="downloadAdministrativeAnexo(item)"
                            >
                              <span>Download</span>
                            </v-btn>
                          </template>

                          <template slot="no-data">
                            <span> Nenhum anexo retornado </span>
                          </template>
                        </v-data-table>
                      </v-tab-item>
                    </v-tabs>
                  </td>
                </template>

                <template slot="no-data">
                  <span> Nenhum relatório administrativo retornado </span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </template>
        <v-row>
          <v-col>
            <v-textarea
              :disabled="report.statusId == 2"
              label="Motivo da rejeição"
              v-model="report.observacoes"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="fechar">Fechar</v-btn>
        <v-btn
          color="info"
          outlined
          text
          @click="save(1)"
          v-if="
            (isAdmin ||
              (config.podeAnalisarProcessoPagamento &&
                groupsConfig.podeAnalisarProcessoPagamento)) &&
            report.statusId == 0
          "
          >Aprovar</v-btn
        >
        <v-btn
          color="info"
          outlined
          text
          @click="updateReport()"
          v-if="report.statusId == 2"
          >Salvar</v-btn
        >
        <v-btn
          color="info"
          outlined
          text
          @click="save(2)"
          v-if="
            (isAdmin ||
              (config.podeAnalisarProcessoPagamento &&
                groupsConfig.podeAnalisarProcessoPagamento)) &&
            report.statusId === 0
          "
          >Rejeitar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="fullScreenDialog" fullscreen>
    <v-card class="full-screen-report-card">
      <v-card-title class="full-screen-report-header">
        <span>Relatório em tela inteira</span>
        <v-spacer></v-spacer>
        <v-btn icon x-large @click="closeFullScreenReport" aria-label="Fechar">
          <v-icon size="38">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="full-screen-report-content">
        <div class="full-screen-report-text">{{ fullScreenReportText }}</div>
      </v-card-text>

      <v-card-actions class="full-screen-report-footer">
        <v-spacer></v-spacer>
        <v-btn large outlined color="primary" @click="closeFullScreenReport">
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
import { paymentReportManagementAPI } from "@/modules/payment-management";
import { mapActions, mapGetters } from "vuex";
import { reportAPI } from "@/modules/report";
import { administrativeReportAPI } from "@/modules/administrative-report";
import ContractInfoCard from "@/components/ContractInfoCard.vue";
import moment from "moment";
export default {
  name: "AppModalAnalyse",
  components: {
    ContractInfoCard,
  },
  props: {
    dialog: { type: Boolean, default: false },
    payload: { type: Object, required: true },
  },
  filters: {
    currency(value) {
      if (!value) return "";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
  },
  data() {
    return {
      headersReport: [
        { text: "Número do Relatório", value: "relatorio.numero" },
        { text: "Total de Relatórios", value: "relatorio.total" },
        { text: "Código da Contratação", value: "relatorio.codigoContratacao" },
        { text: "Perídodo da Realização", value: "relatorio.horasTarefas" },
      ],
      headers: [
        { text: "Título", value: "relatorio.titulo" },
        { text: "Horas", value: "relatorio.horasUtilizadasString" },

        { text: "Município", value: "relatorio.municipio.nome" },
        { text: "Criado por", value: "relatorio.usuario.nome" },
        { text: "Criado em", value: "relatorio.criacao" },
      ],
      headersTarefas: [
        { text: "Tarefa", value: "municipioTarefa.nome" },
        { text: "Cumprida", value: "cumprida" },
        {
          text: "Evidências",
          value: "tarefa.municipioTarefa.municipioEvidencias",
        },
      ],
      headersConvidados: [
        { text: "Nome", value: "convidado.nome" },
        { text: "CPF", value: "convidado.cpf" },
        { text: "E-mail", value: "convidado.email" },
        { text: "Presente", value: "presente" },
      ],
      headersAnexos: [
        { text: "Nome", value: "nome" },
        { text: "", value: "download" },
      ],
      relatorioIdCarregado: false,
      anexosCache: [],
      administrativeReportsCache: {},
      headersAdministrativeReport: [
        {
          text: "#",
          value: "relatorioAdministrativo.relatorioAdministrativoId",
        },
        {
          text: "Título",
          value: "relatorioAdministrativo.titulo",
        },
        {
          text: "Horas",
          value: "relatorioAdministrativo.horas",
        },

        {
          text: "Município",
          value: "relatorioAdministrativo.municipio.nome",
        },
        {
          text: "Criador",
          value: "relatorioAdministrativo.usuario.nome",
        },
      ],
      report: {},
      tab: 0,
      administrativeTab: 0,
      fullScreenDialog: false,
      fullScreenReportText: "",
      contractPanel: [],
      contractInfo: null,
      loadingContract: false,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),

    onAnexosTabClick(item) {
      if (this.relatorioIdCarregado === item.relatorioId) {
        this.report.anexos = this.anexosCache;
        return;
      }
      this.resetarCacheAnexos();
      this.carregarAnexos(item);
    },
    carregarAnexos(item) {
      this.setLoading(true);
      reportAPI
        .getRelatorioAnexos(item.relatorioId)
        .then((resp) => {
          this.anexosCache = resp.data;
          this.report.relatorioPagamento.forEach((relatorio) => {
            relatorio.relatorio.anexos = this.anexosCache.filter(
              (anexo) => anexo.relatorioId === relatorio.relatorioId
            );
          });
          this.relatorioIdCarregado = item.relatorioId;
          this.setLoading(false);
          this.$forceUpdate();
        })
        .catch((error) => {
          console.error("Erro ao carregar anexos:", error);
          this.$notification.error("Erro ao carregar anexos");
          this.setLoading(false);
        });
    },
    fechar() {
      this.tab = 0;
      this.closeFullScreenReport();
      this.resetarCacheAnexos();
      this.$emit("onCloseReport", false);
    },
    openFullScreenReport(text) {
      this.fullScreenReportText = text || "";
      this.fullScreenDialog = true;
    },
    closeFullScreenReport() {
      this.fullScreenDialog = false;
    },
    onItemExpanded() {
      this.tab = 0;
    },
    onAdministrativeItemExpanded({ item, value }) {
      this.administrativeTab = 0;

      if (value) {
        this.loadAdministrativeReportDetails(item);
      }
    },
    loadAdministrativeReportDetails(item) {
      const administrativeReportId =
        item.relatorioAdministrativo.relatorioAdministrativoId;

      if (this.administrativeReportsCache[administrativeReportId]) {
        return;
      }

      this.setLoading(true);
      administrativeReportAPI
        .get(administrativeReportId)
        .then((resp) => {
          this.$set(
            this.administrativeReportsCache,
            administrativeReportId,
            resp.data
          );
          this.setLoading(false);
        })
        .catch((error) => {
          console.error("Erro ao carregar relatório administrativo:", error);
          this.$notification.error(
            "Erro ao carregar dados do relatório administrativo"
          );
          this.setLoading(false);
        });
    },
    getAdministrativeReportDetails(item) {
      const administrativeReportId =
        item.relatorioAdministrativo.relatorioAdministrativoId;

      return (
        this.administrativeReportsCache[administrativeReportId] ||
        item.relatorioAdministrativo ||
        {}
      );
    },
    resetarCacheAnexos() {
      this.anexosCarregados = false;
      this.anexosCache = [];
    },
    updateReport() {
      if (!this.payload.codigoContratacao) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem código de contratação!"
        );
      } else if (!this.payload.periodoRealizacao) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem período de realização!"
        );
      } else if (!this.payload.numero) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem colocar o número do relatório!"
        );
      } else if (!this.payload.total) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem o total de relatórios!"
        );
      } else {
        this.setLoading(true);

        let relatorio = this.payload;
        relatorio.relatorioPagamento = null;
        relatorio.relatorioAdministrativoPagamento = null;
        relatorio.anexos = null;
        relatorio.relatorios = null;
        relatorio.relatoriosAdministrativos = null;
        relatorio.numero = this.report.numero;
        relatorio.total = this.report.total;
        relatorio.codigoContratacao = this.report.codigoContratacao;
        relatorio.periodoRealizacao = this.report.periodoRealizacao;
        relatorio.observacoes = null;

        // let relatorio = this.payload;
        // relatorio.numero = this.report.numero;
        // relatorio.total = this.report.total;
        // relatorio.codigoContratacao = this.report.codigoContratacao;
        // relatorio.periodoRealizacao = this.report.periodoRealizacao;
        // relatorio.observacoes = this.report.observacoes;

        paymentReportManagementAPI
          .update(relatorio)
          .then((resp) => {
            this.setLoading(false);
            this.$emit("onCloseReport", true);
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao atualizar relatório");
          });
      }
    },
    save(statusId) {
      if (statusId === 2 && !this.report.observacoes) {
        this.$notification.error("Favor inserir o motivo da rejeição");
      } else {
        this.setLoading(true);
        this.payload.statusId = statusId;
        this.payload.aprovadorId = this.user.usuarioId;
        this.payload.aprovacao = moment().format("YYYY-MM-DD");

        let relatorio = this.payload;
        relatorio.relatorioPagamento = null;
        relatorio.relatorioAdministrativoPagamento = null;
        relatorio.anexos = null;
        relatorio.relatorios = null;
        relatorio.relatoriosAdministrativos = null;
        relatorio.numero = this.report.numero;
        relatorio.total = this.report.total;
        relatorio.codigoContratacao = this.report.codigoContratacao;
        relatorio.periodoRealizacao = this.report.periodoRealizacao;
        relatorio.contratoId = this.report.contratoId;
        relatorio.observacoes = this.report.observacoes;
        paymentReportManagementAPI
          .analyse(relatorio)
          .then((resp) => {
            this.setLoading(false);
            this.$emit("onCloseReport", true);
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao atualizar relatório");
          });
      }
    },
    downloadAnexo(evidencia) {
      paymentReportManagementAPI
        .downloadAnexo(evidencia.relatorioAnexoId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = evidencia.nome;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter Anexo");
        });
    },
    downloadAnexoProcessoPagamento(anexo) {
      paymentReportManagementAPI
        .downloadAnexoProcessoPagamento(anexo.relatorioGestaoPagamentoAnexoId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = anexo.nome;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter Anexo");
        });
    },
    downloadAdministrativeAnexo(anexo) {
      administrativeReportAPI
        .downloadAnexo(anexo.relatorioAdministrativoAnexoId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = anexo.nome;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error(
            "Erro ao obter anexo do relatório administrativo"
          );
        });
    },
    get() {
      this.setLoading(true);
      paymentReportManagementAPI
        .get(this.payload.relatorioGestaoPagamentoId)
        .then((resp) => {
          this.report = resp.data;
          this.administrativeReportsCache = {};

          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter processo de pagamento");
        });
    },
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "user",
      "isAT",
      "isGov",
      "config",
      "groupsConfig",
    ]),
    canViewFullScreenReport() {
      return (
        this.config?.verRelatorioTelaInteira &&
        this.groupsConfig?.verRelatorioTelaInteira
      );
    },
  },
  watch: {
    dialog(value) {
      if (value) {
        this.get();
      }
    },
  },
  mounted() {
    if (this.isGov) {
      this.headers = [
        { text: "Título", value: "relatorio.titulo" },
        { text: "Projeto", value: "relatorio.municipio.nome" },
        { text: "Criado por", value: "relatorio.usuario.nome" },
        { text: "Criado em", value: "relatorio.criacao" },
      ];

      this.headersAdministrativeReport = [
        {
          text: "#",
          value: "relatorioAdministrativo.relatorioAdministrativoId",
        },
        {
          text: "Título",
          value: "relatorioAdministrativo.titulo",
        },
        {
          text: "Projeto",
          value: "relatorioAdministrativo.municipio.nome",
        },
        {
          text: "Criador",
          value: "relatorioAdministrativo.usuario.nome",
        },
        {
          text: "Horas",
          value: "relatorioAdministrativo.horas",
        },
      ];
    }
  },
};
</script>

<style lang="scss">
@import "./style.scss";

// Estilos do expansion panel de contrato - versão compacta
.contract-expansion-panels {
  .v-expansion-panel {
    box-shadow: 0 2px 8px rgba(25, 118, 210, 0.12) !important;
    border-radius: 8px !important;
    overflow: hidden;
    border: 1px solid rgba(25, 118, 210, 0.15);

    &::before {
      box-shadow: none !important;
    }
  }
}

.contract-panel-header {
  border-radius: 8px 8px 0 0 !important;
  padding: 2px 10px !important;
  min-height: 40px !important;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 3px 12px rgba(25, 118, 210, 0.25);
  }

  .v-expansion-panel-header__icon {
    color: white !important;

    .v-icon {
      color: white !important;
    }
  }
}

.icon-wrapper {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.panel-title {
  font-size: 1rem;
  font-weight: 600;
  color: white;
  line-height: 1.2;
}

.contract-panel-content {
  background: #fafbfc;
  border-radius: 0 0 8px 8px;

  .v-expansion-panel-content__wrap {
    padding: 20px !important;
  }
}

.anexo-nome {
  word-break: break-word;
  max-width: 200px;
  display: inline-block;
}
</style>
